function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}


var bulmaSelectWrapper = (rootSelector = null) => {
    let root = rootSelector ? document.querySelector(rootSelector) : document;
    root.querySelectorAll('select').forEach(function (selectElement) {
        const wrapper = document.createElement('div');
        wrapper.style.width = '100%';
        wrapper.className = 'select';
        selectElement.parentNode.insertBefore(wrapper, selectElement);
        wrapper.appendChild(selectElement);
    });
}

var setTimezoneInCookie = () => {
    // only if timezone is not set
    if (!getCookie('timezone')) {
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        setCookie('timezone', timezone, 365);
    }
}

var progressBarInitializer = () => {
    let progressBars = document.querySelectorAll('.gp-bar');
    progressBars.forEach(function (bar) {
        let percent = bar.getAttribute('data-percent');
        // Start at 0% width and animate to the target percent
        bar.style.width = "0%";
        setTimeout(() => {
            bar.style.width = `${percent}%`;
        }, 100); // Short delay to ensure animation
    });
}

document.addEventListener('DOMContentLoaded', () => {
    countdownInitializer();
    progressBarInitializer();
    drawerController();
    bulmaSelectWrapper();
    remoteModalHandler();
    localModalHandler('body');
    setTimezoneInCookie();
    pomodoroHandler();
    pendingBoxHandler();
    dropDownHandler();
    evolutionHandler();
});